"use client";

import Link from "next/link";
import { m } from "framer-motion";
import { cn } from "@/lib/shared/utils";
import EditableText from "@/components/edit-mode/EditableText";

interface BrandMarkProps {
  logo: string;
  compact: boolean;
  href?: string;
}

export default function BrandMark({ logo, compact, href = "/" }: BrandMarkProps) {
  return (
    <Link
      href={href}
      aria-label={`${logo} -- home`}
      className="group relative inline-flex cursor-pointer items-baseline"
    >
      <span
        className={cn(
          "glitch-text relative z-10 block tracking-tighter transition-all duration-500 group-hover:tracking-[0.05em]",
          compact ? "text-xl" : "text-xl md:text-2xl"
        )}
        style={{
          fontFamily: "var(--font-brand-name)",
          fontWeight: "var(--brand-weight)",
        }}
      >
        <EditableText section="header" field="logo" value={logo} />
        <m.span
          aria-hidden
          className="h-px w-0 bg-current"
          initial={{ width: 0 }}
          whileHover={{ width: "100%" }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        />
      </span>
    </Link>
  );
}
